import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import MatchProfile from "./components/MatchProfile";
import { useParams } from "react-router-dom";
import HomeLayout from "./HomeLayout";

const MatchProfilePage = () => {
  const { id } = useParams();

  return (
    <>
      <HomeLayout>
        <MatchProfile matchId={parseInt(id)} />
      </HomeLayout>
    </>
  );
};

export default MatchProfilePage;
